import React from 'react'

import './AIStatusBanner.scss'

interface AIStatusBannerProps {
  readonly text?: string
}

const AIStatusBanner: React.FC<AIStatusBannerProps> = ({ text }) => {
  return (
    <div className="AIStatusBanner">
      <div className="AIStatusBanner__content">
        <span className="AIStatusBanner__text">
          {text || (
            <React.Fragment>
              ✨ AI is analyzing your video...
              <br />
              Demo: Generating a 3-minute Magic Preview for instant results.
            </React.Fragment>
          )}
        </span>
      </div>
      <div className="AIStatusBanner__track">
        <div className="AIStatusBanner__bar" />
      </div>
    </div>
  )
}

export default AIStatusBanner
